import React, { Component, ErrorInfo, ReactNode } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { PageVariant } from 'ui-library';
import PageVariantWrapper from '../PageVariantWrapper';
import './ErrorBoundary.css';

interface ErrorBoundaryProps extends WithTranslation {
    navigate: (path: string) => void; // Assuming react-router navigate function
    children: ReactNode;
}

interface ErrorBoundaryState {
    error: Error | null;
    errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {
            error: null,
            errorInfo: null,
        };
    }

    backToDashboard = () => {
        const { navigate } = this.props;

        navigate('/dashboard');
        window.location.reload();
    };

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.setState({
            error,
            errorInfo,
        });
    }

    render() {
        const {
            state: { error, errorInfo },
            props: { t },
        } = this;

        if (errorInfo) {
            return (
                <PageVariantWrapper className="ErrorBoundary">
                    <PageVariant
                        type="error"
                        title={t('advisoryDashboard.error')}
                        message={t('advisoryDashboard.errorText')}
                        actionButtonLabel={t('common.backToDashboard')}
                        onActionButtonClick={this.backToDashboard}
                    />
                </PageVariantWrapper>
            );
        }

        return this.props.children;
    }
}

export default withTranslation()(ErrorBoundary);
